/* eslint-disable prefer-promise-reject-errors */

/* eslint-disable consistent-return */

import axios from 'axios'
import endpoints from '../configs/endpoints'

class AuthService {
    /** call login endpoint */
    login({ username, password }) {
        return new Promise((resolve, reject) => {
            const url = window._env_.isWebpack
                ? '/loans/v1/auth/login'
                : endpoints.baseTTSServiceUrl + endpoints.authUrl

            const loginReq = { username, password }
            const loginHeaders = { 'Content-Type': 'application/json' }
            try {
                axios
                    .post(url, loginReq, { headers: loginHeaders })
                    .then(response => {
                        /** validate status */
                        if (response.status !== 200) {
                            return reject(Error(response.status))
                        }
                        /** validate token */
                        const { accessToken } = response.data
                        if (!accessToken || accessToken === '') {
                            return reject(Error('Login Failed'))
                        }
                        /** resolve result */
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            } catch (e) {
                reject(e)
            }
        })
    }

    forgetPassword({ username }) {
        return new Promise((resolve, reject) => {
            const url = window._env_.isWebpack
                ? '/loans/v1/auth/forgot-password'
                : endpoints.baseTTSServiceUrl + endpoints.forgetPassword
            const loginReq = { username }
            const loginHeaders = { 'Content-Type': 'application/json' }
            try {
                axios
                    .post(url, loginReq, { headers: loginHeaders })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.message) {
                            reject({ result: error.response.data.message })
                        } else {
                            reject({ result: 'PASSWORD_RESET_USERNAME_NOT_FOUND' })
                        }
                    })
            } catch (e) {
                reject(e)
            }
        })
    }

    resetPassword({ verificationToken, password }) {
        return new Promise((resolve, reject) => {
            const url = window._env_.isWebpack
                ? '/loans/v1/auth/reset-password'
                : endpoints.baseTTSServiceUrl + endpoints.resetPassword

            const loginReq = { verificationToken, password }
            const loginHeaders = { 'Content-Type': 'application/json' }
            try {
                axios
                    .post(url, loginReq, { headers: loginHeaders })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.message) {
                            reject({ result: error.response.data.message })
                        } else {
                            reject({ result: 'PASSWORD_RESET_VERIFICATION_CODE_ERROR' })
                        }
                    })
            } catch (e) {
                reject(e)
            }
        })
    }
}

export default new AuthService()
